import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.scss';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>
      <div className="legal-content">
        <p>Last updated: {new Date().toLocaleDateString()}</p>
        
        <h2>1. Information We Collect</h2>
        <p>We collect information you provide directly to us:</p>
        <ul>
          <li>Account information (name, email, password)</li>
          <li>Payment information</li>
          <li>Content you submit for conversion</li>
          <li>Usage data and preferences</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide and maintain the Service</li>
          <li>Process your payments</li>
          <li>Send you updates and communications</li>
          <li>Send marketing information about our TTS services when you provide your email and use our free TTS converter</li>
          <li>Improve and optimize our Service</li>
          <li>Protect against fraud and abuse</li>
        </ul>

        <h2>2.1 Marketing Communications</h2>
        <p>By providing your email address and using our free TTS converter, you consent to receive marketing communications about our TTS services. You can opt-out of these communications at any time by clicking the unsubscribe link in any marketing email or by contacting us directly.</p>

        <h2>3. Information Sharing</h2>
        <p>We do not sell your personal information. We may share your information:</p>
        <ul>
          <li>With service providers who assist in our operations</li>
          <li>When required by law</li>
          <li>To protect our rights and safety</li>
        </ul>

        <h2>4. Data Security</h2>
        <p>We implement appropriate security measures to protect your personal information.</p>

        <h2>5. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal information</li>
          <li>Correct inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Object to processing of your data</li>
        </ul>

        <h2>6. California Privacy Rights</h2>
        <p>If you are a California resident, you have the following additional rights under the California Consumer Privacy Act (CCPA) and California Privacy Rights Act (CPRA):</p>
        <ul>
          <li>The right to know what personal information we collect and how it is used and shared</li>
          <li>The right to delete personal information collected from you</li>
          <li>The right to correct inaccurate personal information</li>
          <li>The right to limit the use and disclosure of sensitive personal information</li>
          <li>The right to opt-out of the sharing of personal information</li>
          <li>The right to non-discrimination for exercising your CCPA rights</li>
        </ul>
        <p>To exercise your California privacy rights, you can:</p>
        <ul>
          <li>Email us at ryan@audioread.com</li>
          <li>Submit a request through our website</li>
          <li>Call us at +1 (951) 666-3443</li>
        </ul>
        <p>We will respond to verifiable consumer requests within 45 days.</p>

        <h2>7. Cookie Policy</h2>
        <p>Our Service uses cookies and similar technologies to improve user experience and analyze Service usage. For detailed information about the cookies we use and your choices regarding cookies, please see our <Link to="/terms">Cookie Policy</Link> section in our Terms of Service. You can also manage your cookie preferences at any time through our <button 
          onClick={() => window.openCookieManager?.()} 
          style={{ 
            background: 'none', 
            border: 'none', 
            color: '#007bff', 
            padding: 0, 
            cursor: 'pointer', 
            textDecoration: 'underline' 
          }}
        >Cookie Management Tool</button>.</p>

        <h2>8. Children's Privacy</h2>
        <p>Our Service is not directed to children under 13. We do not knowingly collect information from children under 13.</p>

        <h2>9. International Data Transfers</h2>
        <p>Your information may be transferred and processed in countries other than your own. When we transfer personal data outside of the EEA or UK, we ensure an adequate level of protection is provided.</p>

        <h2>10. Data Retention</h2>
        <p>We retain your personal information for as long as necessary to provide our services and fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required by law.</p>

        <h2>11. Changes to Privacy Policy</h2>
        <p>We may update this policy from time to time. We will notify you of any material changes.</p>

        <h2>Contact Us</h2>
        <p>For privacy-related questions, please contact:</p>
        <p>Audioread by Astrophe, LLC<br />
        8 The Green, Suite 300<br />
        Dover, DE 19901<br />
        Email: ryan@audioread.com<br />
        Phone: +1 (951) 666-3443</p>

        <p>EU Representative (for GDPR purposes):<br />
        Ryan Walter<br />
        8 The Green, Suite 300<br />
        Dover, DE 19901<br />
        Email: ryan@audioread.com</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 